import { ReferentialKey } from 'api/referential';
import { SearchFilterEnum } from 'api/actor';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { GestionnaireFormFieldNames } from './GestionnaireFormFieldNames';
import { GestionnaireFormValues } from './GestionnaireFormValues';

import { gerantInputsConfig } from 'back-office/shared/components/gerant/gerantFields';
/** Champs rendus via InputFactory — les comptes bancaires ont leur propre
 * composant (liste dynamique) et ne passent pas par ce config. */
export type GestionnaireInputFieldName = Exclude<keyof GestionnaireFormValues, 'bankAccounts'>;

export const gestionnaireInputsConfig: InputsConfig<GestionnaireInputFieldName> = {
  ...gerantInputsConfig,
  ...addressInputsConfig,
  [GestionnaireFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.GESTIONNAIRE.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.GESTIONNAIRE.PLACEHOLDERS.COMPANY_NAME',
  },
  [GestionnaireFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Phone,
    type: 'tel',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PHONE',
  },
  [GestionnaireFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.REGISTRATION_NUMBER',
  },
  [GestionnaireFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Capital,
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.CAPITAL',
    min: 0,
  },
  [GestionnaireFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_CITY',
  },
  [GestionnaireFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_NUMBER',
  },
  [GestionnaireFormFieldNames.OriasNumber]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.OriasNumber,
    type: 'text',
    required: false, // optionnel pour la nature Gestionnaire
    label: 'ACTOR_FORM.BROKER.LABELS.ORIAS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.ORIAS_NUMBER',
  },
  [GestionnaireFormFieldNames.Rcp]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Rcp,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.RCP',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCP',
  },
  [GestionnaireFormFieldNames.ComplaintEmail]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.ComplaintEmail,
    type: 'email',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.COMPLAINT_EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.COMPLAINT_EMAIL',
  },
  [GestionnaireFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.FIRST_NAME',
  },
  [GestionnaireFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.LAST_NAME',
  },
  [GestionnaireFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Email,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 500,
      errorMessage: 'Cette adresse email existe déjà',
    },
  },
  [GestionnaireFormFieldNames.Username]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Username,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.USERNAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.USERNAME',
  },
  [GestionnaireFormFieldNames.Password]: {
    componentKey: ComponentKey.InputText,
    name: GestionnaireFormFieldNames.Password,
    type: 'password',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.PASSWORD',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PASSWORD',
  },
  [GestionnaireFormFieldNames.PlateformeIds]: {
    componentKey: ComponentKey.ReferentialTagInput,
    name: GestionnaireFormFieldNames.PlateformeIds,
    referentialKey: ReferentialKey.Plateforme,
    label: 'COMMON.LABELS.ORGANIZATIONS',
    placeholder: 'COMMON.PLACEHOLDERS.ORGANIZATIONS',
    required: true,
  },
};
